module.exports = __webpack_public_path__ + "create.png?34f2fb793eabcf7a6e5a009aca19a461";